export const getCorrectHydroBasePath = (locale: string) => {
  return locale.startsWith('fr') ? 'spots-de-peche' : 'fishing-spots'
}
